import { SearchEngine } from './common'

class PolyglotEngine extends SearchEngine {
  constructor (fieldSpecifiers) {
    super('Polyglot')
  }
  formTerm (text, isNegative, addQuotes, fieldSpecifier) {
    let r = ''
    if (isNegative) {
      r += 'NOT '
    }
    if (addQuotes) {
      r += '"'
    }
    r += text
    if (addQuotes) {
      r += '"'
    }
    if (fieldSpecifier && fieldSpecifier.length > 0) {
      r += '[' + fieldSpecifier + ']'
    }
    return r
  }
}

export default PolyglotEngine



// WEBPACK FOOTER //
// ./src/formulate_queries/PolyglotEngine.js